"use strict";
// The open marketplace, as a first-party plugin: it hosts THIRD-PARTY plugins
// and themes (contract: @dunea/plugin-sdk). Declared here because the bridge
// uses core extension points like any plugin: it subscribes to internal events
// (forwarded as signed webhooks to installs that may see them) and provides a
// deploy transform (approved third-party site scripts, after visitor consent).
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETPLACE_PLUGIN = void 0;
exports.MARKETPLACE_PLUGIN = {
    id: 'marketplace',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Marketplace',
    description: 'Plugins and themes from the Dunea community.',
    icon: 'i-ph:storefront',
    agentCard: 'Marketplace: community plugins (their AI tools appear in your toolset when installed) and themes (apply_theme) — browse in the Marketplace panel.',
    surfaces: ['web-app'],
    provides: {
        // After marketing (10): third-party scripts load through the same consent runtime.
        'core.deploy.transform': { major: 1, meta: { order: 30 } },
    },
    subscribes: [
        'core.app.published',
        'shop.order.paid',
        'shop.order.fulfilled',
        'shop.order.refunded',
        'shop.stock.low',
        'payments.payment.succeeded',
        'payments.payment.refunded',
        'forms.submitted',
        'funnels.lead.captured',
        'reviews.submitted',
        // Its own events, for in-module reactions: a paid template's license
        // activating creates the remix; a remix binds referral attribution; a
        // removed theme install takes its theme.css out of the app.
        'marketplace.install.activated',
        'marketplace.install.removed',
        'marketplace.remix.created',
    ],
    emits: {
        'marketplace.install.activated': {
            major: 1,
            description: 'A marketplace plugin or theme became active on an app.',
        },
        'marketplace.install.removed': { major: 1, description: 'A marketplace install was uninstalled or suspended.' },
        'marketplace.remix.created': { major: 1, description: 'A user started a new project from a template listing.' },
    },
    permissions: ['db:own-tables', 'network:third-party-webhooks'],
};
